import React from 'react';
import { element, string, any, arrayOf, exact } from 'prop-types';

import { useUrlParam } from './utils';

import './Tabs.scss';

export default function Tabs({ children, activeTab, tabs }) {
  const { setUrlParam, deleteUrlParam } = useUrlParam();

  return (
    <div className="Tabs">
      <div className="Tabs__head">
        {tabs.map(tab => (
          <div
            key={tab.caption}
            className={`Tabs__headItem ${activeTab === tab.value && 'active'}`}
            onClick={() => {
              setUrlParam('tags', tab.value);
              deleteUrlParam('page');
            }}
          >
            <p>{tab.caption}</p>
          </div>
        ))}
      </div>

      <div className="Tabs__content">{children}</div>
    </div>
  );
}

Tabs.propTypes = {
  children: element.isRequired,
  activeTab: string.isRequired,
  tabs: arrayOf(exact({ value: any, caption: string })).isRequired,
};
